<template>
  <v-card flat>
    <v-card-text class="pa-0" v-if="!canChat">
      <v-row>
        <v-col class="text-center">
          <v-icon color="red" size="36">fa-exclamation-circle</v-icon>
          <h4>Chat bloqueado</h4>
          <p>
            Este pedido veio do site. Por favor, entre em contato com o cliente
            caso haja modificações no pedido ou precise de mais informações.
          </p>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text
      class="pa-0 px-3"
      style="max-height: 600px; overflow-y: auto;"
      id="messagesArea"
    >
      <v-row
        v-for="(m, i) in messages"
        :key="i"
        class="text-start pa-3 mt-2"
        :class="m.className"
        no-gutters
      >
        <v-col
          class="font-weight-bold black--text mb-2"
          style="font-size: 1.1em;"
        >
          {{ m.nomecliente }}
        </v-col>
        <v-col cols="auto">
          <small>
            {{ m.datamensagem | formatDateTime(getTimeZone) }}
          </small>
        </v-col>
        <v-col cols="12">
          <span v-if="!m.file" class="px-2 black--text">{{ m.mensagem }}</span>
          <div v-if="m.file" class="pa-2">
            <a :href="m.file" target="_blank">
              <v-img
                class="mx-auto"
                v-if="m.showImg"
                :src="m.file"
                max-width="40vh"
                @error="handleImgError(m)"
              />
              <span v-if="!m.showImg">Arquivo</span>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider class="mt-2" />
    <v-card-actions>
      <v-row v-if="canChat" no-gutters class="mt-3 mb-n5">
        <v-col cols="auto" class="mr-n3">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon size="14" v-on="on" class="d-flex float-end ml-2 mt-n3">
                far fa-question-circle
              </v-icon>
            </template>
            Formatos aceitos: .pdf | .jpeg | .jpg | .png | .webp
          </v-tooltip>
          <FormFile
            v-on="on"
            label="Arquivo"
            v-model="form.nameCurrentFile"
            @file="onSelectFile"
            hiddenText
          />
        </v-col>
        <v-col>
          <v-text-field
            outlined
            dense
            rounded
            v-model="form.message"
            @keyup.enter="enviarMensagem"
            placeholder="escreva aqui sua mensagem..."
          />
        </v-col>
        <v-col cols="auto">
          <FormButton
            class="font-weight-bold ml-3"
            @click="enviarMensagem"
            type="primario"
          >
            Enviar
          </FormButton>
        </v-col>
      </v-row>
      <p v-else class="pt-3">
        O envio de mensagens relacionadas a este pedido foi encerrado
      </p>
    </v-card-actions>
  </v-card>
</template>

<script>
import OrderStatus from "../../../../utils/orderStatus";
import { mapGetters } from "vuex";
import * as _ from "lodash";
import { PEDIDO_CHAT, PEDIDO_CHAT_IMAGE } from "@/store/actions/pedido";
import FormButton from "@/components/form/FormButton";
import FormFile from "@/components/form/FormFile";
import ApiWeb from "../../../../service/api-web";
import io from "socket.io-client";
import Cookies from "js-cookie";

export default {
  name: "PedidoChat",
  components: {
    FormButton,
    FormFile
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      form: { message: "" },
      messages: [],
      bucketRoot: "",
      canChat: true,
      chatsocket: null,
      socketUrl: null,
      numeroPedido: this.pedido.numpedido,
      tipoArquivos: [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp"
      ]
    };
  },
  computed: {
    ...mapGetters(["getFornecedorId", "getTimeZone"])
  },
  methods: {
    initChat() {
      this.getMensagensChat();
      this.canChat = ![
        OrderStatus.OrderStatus.ENTREGUE,
        OrderStatus.OrderStatus.CANCELADO
      ].includes(this.pedido.statuspedido);
      this.getUrlSocket();
    },
    formatMessage(origem, datamensagem, mensagem, metadados) {
      const attachment = _.get(metadados, "attachment") || "";
      const file = attachment ? `${this.bucketRoot}/${attachment}` : "";
      return {
        className: origem === "c" ? "right" : "left",
        nomecliente: origem === "c" ? this.pedido.nomecliente : "Atendimento",
        datamensagem: datamensagem,
        mensagem,
        file,
        showImg: true
      };
    },
    getformatedMessages({ messages }) {
      return (messages || []).map(m => {
        const temp = {
          origem: m.origem,
          nomecliente:
            m.origem === "c" ? this.pedido.nomecliente : "Atendimento",
          datamensagem: new Date(m.datamensagem * 1000),
          mensagem: m.mensagem,
          metadados: m.metadados
        };
        return this.formatMessage(
          temp.origem,
          temp.datamensagem,
          temp.mensagem,
          temp.metadados
        );
      });
    },
    getMensagensChat() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_CHAT, this.pedido.numpedido)
        .then(data => {
          this.bucketRoot = data.bucketRoot;
          this.messages = this.getformatedMessages(data);
          this.isLoading = false;
          this.chatBoxToBottom();
          this.markAsRead();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    enviarMensagem(message, metadados) {
      const msg = typeof message === "string" ? message : this.form.message;
      if (msg !== "") {
        const mensagem = {
          txt: msg,
          origem: "f",
          idusuario: "0",
          idcliente: this.pedido.idcliente,
          codpedido: this.numeroPedido,
          metadados
        };

        if (this.chatsocket) {
          this.chatsocket.emit("new-chat-message", mensagem);
        }
      }
      this.form.message = "";
    },
    getUrlSocket() {
      ApiWeb.v4.chat
        .getUrl()
        .then(resp => {
          const { socketUrl } = resp.data;
          if (!socketUrl) {
            this.$vueOnToast.pop(
              "error",
              "Erro ao buscar configuração do Socket"
            );
          } else {
            this.socketUrl = socketUrl;
            this.initSocket();
          }
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err);
        });
    },
    initSocket() {
      if (io && !this.chatsocket) {
        const authorizationCookie = Cookies.get("authorization");
        this.chatsocket = io(this.socketUrl, {
          transports: ["websocket"],
          query: {
            token: authorizationCookie
          },
          auth: {
            token: authorizationCookie
          }
        });
        this.chatsocket.emit("startup-handshake", {
          idusuario: 0,
          codpedido: this.numeroPedido
        });

        this.chatsocket.on("new-message-sent", mensagem => {
          const dtMsg = new Date(mensagem.timestamp);
          this.messages.push(
            this.formatMessage("f", dtMsg, mensagem.txt, mensagem.metadados)
          );
          this.chatBoxToBottom();
        });

        this.chatsocket.on("new-message-received", mensagem => {
          this.messages.push(
            this.formatMessage(
              mensagem.origem,
              new Date(),
              mensagem.txt,
              mensagem.metadados
            )
          );
          this.chatBoxToBottom();
          this.notificarDesktop(
            `Mensagem de ${this.pedido.nomecliente}`,
            mensagem.txt
          );
          this.markAsRead();
        });
      }
    },
    handleImgError(message) {
      message.showImg = false;
    },
    markAsRead() {
      if (this.chatsocket) {
        this.chatsocket.emit("mark-as-read", {
          sala: `CODPED:${this.numeroPedido}`,
          idfornecedor: this.getFornecedorId,
          origem: "c"
        });
      }
    },
    notificarDesktop(titulo, mensagem) {
      if (Notification.permission === "granted") {
        new Notification(titulo, { body: mensagem });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            new Notification(titulo, { body: mensagem });
          }
        });
      }
    },
    chatBoxToBottom() {
      setTimeout(() => {
        const objDiv = document.getElementById("messagesArea");
        if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      }, 300);
    },
    onSelectFile(file) {
      if (!this.getAcceptedFiles(file.type)) {
        this.$vueOnToast.pop(
          "error",
          `O formato do arquivo selecionado é inválido! (${file.type})`
        );
        this.form.nameCurrentFile = null;
        return;
      }
      const size = 100 * 1024 * 1024;
      if (file.size > size) {
        this.$vueOnToast.pop(
          "error",
          "Arquivo superior a 100mb, selecione um arquivo menor!"
        );
      }
      this.form.currentFile = file;
      const formData = new FormData();
      formData.append("file", this.form.currentFile);
      this.$store
        .dispatch(PEDIDO_CHAT_IMAGE, {
          idpedido: this.pedido.idpedido,
          formData: formData
        })
        .then(response => {
          this.isLoading = false;
          const msg =
            _.get(response, "Mensagem") || "Arquivo enviado com sucesso.";
          this.$vueOnToast.pop("success", msg);
          const file = _.get(response, "metadados");
          this.enviarMensagem(msg, file);
          setTimeout(() => {
            this.getMensagensChat();
          }, 500);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Ocorreu um erro no envio do arquivo.";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    getAcceptedFiles(type) {
      return this.tipoArquivos.filter(t => t == type).length > 0;
    }
  },
  created() {
    this.initChat();
  }
};
</script>

<style>
.right {
  border-radius: 10px;
  background-color: #9ad180;
  margin-left: 40px;
}
.left {
  border-radius: 10px;
  background-color: #e8e9eb;
  margin-right: 40px;
}
</style>
